export enum OutfitActionTypeEnum {
  TAP_FULL_OUTFIT = 'TAP_FULL_OUTFIT',
  TAP_MIX_AND_MATCH_ITEM = 'TAP_MIX_AND_MATCH_ITEM',
  TAP_COLOUR = 'TAP_COLOUR',
}
